module.exports = __webpack_public_path__ + "img/lindsey-chapman.408c76c2.jpg";